
    import {Component, Prop, Vue} from 'vue-property-decorator';
    @Component
    export default class Modal extends Vue {
        @Prop({default: 500})
        private width!: number;
        @Prop({default: true})
        private closeOnClickOutside!: boolean;
    }
